<template>
  <div>
    <v-col class="col-12">
      <!-- region selector -->
      <v-row>
        <v-col class="col-4 py-0">
          <destination-selector
            :selectedDestination.sync="selectedDestination"
            permission="EDIT_EXTERNAL_URL"
          />
        </v-col>
      </v-row>

      <v-row v-if="destinationIsSelected">
        <v-col class="col-12">
          <!-- Edit external URL -->
          <h3>
            {{ $t('powerBiManagement.editPowerBis') }}
          </h3>
          <v-data-table
            :headers="headersEdit"
            :items="externalUrlsEdit"
            item-key="id"
            :no-data-text="$t('powerBiManagement.noDataAvailable')"
            :footer-props="{
              itemsPerPageOptions: [-1, 5, 20],
              itemsPerPageText: $t('general.rowsPerPage'),
              itemsPerPageAllText: $t('dataTable.allRows'),
            }"
          >
            <template #body="{ items }">
              <tr
                v-for="(externalUrl, externalUrlIndex) in items"
                :key="externalUrlIndex"
              >
                <td>
                  <v-text-field
                    v-model="externalUrl.name"
                    dense
                    outlined
                    hide-details
                  />
                </td>
                <td>
                  <v-text-field
                    v-model="externalUrl.url"
                    outlined
                    dense
                    hide-details
                  />
                </td>
                <td align="end">
                  <v-btn outlined @click="savePowerBi(externalUrl)">
                    <span class="fal fa-save mr-2" />
                  </v-btn>
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-col>

        <!-- Connect role withe external URL -->
        <v-col v-if="externalUrls && externalUrls.length" class="col-12 pt-0">
          <h3>
            {{ $t('powerBiManagement.connectPowerBis') }}
          </h3>
          <v-data-table
            :headers="headersConnect"
            :items="externalUrls"
            :no-data-text="$t('powerBiManagement.noDataAvailable')"
            :footer-props="{
              itemsPerPageOptions: [-1, 5, 20],
              itemsPerPageText: $t('general.rowsPerPage'),
              itemsPerPageAllText: $t('dataTable.allRows'),
            }"
          >
            <template #body="{ items }">
              <tbody>
                <tr
                  v-for="(externalUrl, externalUrlIndex) in items"
                  :key="externalUrlIndex"
                >
                  <!-- power Bi -->
                  <td>
                    {{ externalUrl.name }}
                  </td>

                  <!-- roles -->
                  <td>
                    <v-row>
                      <!-- iterate available roles -->
                      <v-col
                        v-for="(
                          availableRole, availableRoleIndex
                        ) in availableRoles.roles"
                        :key="availableRoleIndex"
                        class="col-3 py-0"
                      >
                        <v-checkbox
                          :input-value="externalUrl.hasRole(availableRole.id)"
                          :label="availableRole.name"
                          @change="flipRole(availableRole, externalUrl)"
                        />
                      </v-col>
                    </v-row>
                  </td>
                </tr>
              </tbody>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
    </v-col>
  </div>
</template>

<script>
import definitions from '../../../definitions'
import DestinationSelector from './DestinationSelector'
import ExternalUrlService from '../../classes-shared/externalUrl/ExternalUrlService'
import Roles from '../../classes-shared/roles/Roles'
import ExternalUrlModel from '../../classes-shared/externalUrl/ExternalUrlModel'

export default {
  name: 'PowerBiManagement',
  components: { DestinationSelector },
  data() {
    return {
      selectedDestination: null,
      permission: definitions.permissions.shopApi.EDIT_EXTERNAL_URL,
      externalUrlService: new ExternalUrlService(),
      availableRoles: new Roles(),
      externalUrls: [],
      externalUrlsEdit: [],
    }
  },
  computed: {
    headersEdit() {
      return [
        {
          text: 'Name',
          align: 'left',
          sortable: true,
        },
        {
          text: 'URL',
          align: 'left',
          sortable: false,
        },
        {
          text: '',
          sortable: false,
        },
      ]
    },
    headersConnect() {
      return [
        {
          text: 'Power BI',
          align: 'left',
          sortable: true,
        },
        {
          text: 'Role',
          align: 'left',
          sortable: false,
        },
      ]
    },
    destinationIsSelected() {
      return (
        this.selectedDestination !== null &&
        this.selectedDestination !== undefined
      )
    },
  },
  watch: {
    async selectedDestination() {
      await this.setExternalUrlLists()
      await this.availableRoles.loadAvailableRolesForRegion(
        this.selectedDestination?.getSlug()
      )
    },
  },
  methods: {
    async setExternalUrlLists() {
      this.externalUrls = await this.externalUrlService.getAllExternalUrlsForRegionByType(
        'powerbi',
        this.selectedDestination.getSlug()
      )
      this.externalUrlsEdit = this.clonePowerBiArray(this.externalUrls)
      this.externalUrlsEdit.push(
        new ExternalUrlModel({
          id: -1,
          name: 'neu',
          url: '',
          type: 'powerbi',
        })
      )
    },
    async flipRole(role, externalUrl) {
      if (externalUrl.hasRole(role.id)) {
        await this.externalUrlService.disconnectExternalUrlToRole(
          externalUrl.id,
          role.id,
          this.selectedDestination.getSlug()
        )
      } else {
        await this.externalUrlService.connectExternalUrlToRole(
          externalUrl.id,
          role.id,
          this.selectedDestination.getSlug()
        )
      }
      this.externalUrls = await this.externalUrlService.getAllExternalUrlsForRegionByType(
        'powerbi'
      )
    },
    async savePowerBi(externalUrl) {
      if (externalUrl.id === -1) {
        if (!externalUrl.url || externalUrl.url === '') {
          EventBus.$emit('notify', this.$t('powerBi.urlMustNotBeEmpty'))
        } else {
          await this.externalUrlService.addExternalUrls(
            externalUrl,
            this.selectedDestination.getSlug()
          )
        }
      } else {
        await this.externalUrlService.updateExternalUrls(
          externalUrl,
          this.selectedDestination.getSlug()
        )
      }
      await this.setExternalUrlLists()
    },
    clonePowerBiArray(externalUrls) {
      let result = []
      externalUrls.forEach((externalUrl) => {
        result.push(
          new ExternalUrlModel({
            id: externalUrl.id,
            regionId: externalUrl.regionId,
            name: externalUrl.name,
            type: externalUrl.type,
            url: externalUrl.url,
            externalUrlRoles: externalUrl.externalUrlRoles,
          })
        )
      })
      return result
    },
  },
}
</script>
